import React from 'react';
import { signInWithPopup } from "firebase/auth";
import { auth, provider } from "./firebase";

function SignInButton(): React.ReactElement {
  const login = async (): Promise<void> => {
    try {
      const result = await signInWithPopup(auth, provider);
      console.log(result.user); // logged in user
    } catch (err) {
      console.error(err);
    }
  };

  return <button onClick={login}>Sign in with Google</button>;
}

export default SignInButton;
